"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import axios from "axios";

export default function PageViewTracker() {
  const pathname = usePathname();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);

  useEffect(() => {
    if (executeRecaptcha) {
      executeRecaptcha().then((t) => {
        setRecaptchaToken(t);
      });
    }
  }, [executeRecaptcha, pathname]);

  useEffect(() => {
    if (!recaptchaToken) {
      return;
    }

    axios
      .post(
        process.env.NEXT_PUBLIC_API_URL + "/track-pageview",
        { path: location.pathname, token: recaptchaToken },
        {
          timeout: 600000,
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(() => {
        setRecaptchaToken(null);
      });
  }, [pathname, recaptchaToken]);

  return null;
}
